import { createContext } from 'react';

const GrowPageContext = createContext(null);

export default GrowPageContext;
